import kalb from './../../images/m.jpg'
import money from './../../images/mony.jpg'

export const commentData=[
    {
        id:1,
        desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi inventore veritatis nesciunt tempora eum quae consequuntur quos facilis",
        name:"Mohammad Maruf",
        userId:1,
        profilePicture:kalb,
    },

    {
        id:2,
        desc:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi inventore veritatis nesciunt tempora eum quae consequuntur quos facilis",
        name:"Mohammad Asif",
        userId:2,
        profilePicture:money,
    },
]